export const DEFAULT_LOCALE = 'zh';
export const LOCALE_LIST = ['zh'];
